export default "/images/grab-area.svg";